import React, { useEffect, useRef, useState } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useCartContext } from "../context/CartContext";

// Imports
import Topbar from "./Topbar";
import Navbar from "./Navbar";
import AuthComponent from "./AuthComponent";
import CartComponent from "./CartComponent";
import Footer from "./Footer";
import TCPP from "./TC&PP";
import TC from "./T&C";
import Notification from "./Notification";
import BottomNavbar from "./BottomNavbar";
import { useTestContext } from "../context/TestContext";
import ChatBot from "./ChatBot";

const UIWrapper = ({ searchVisible, children, locationVisibility = true }) => {
  const {
    isAuth,
    isTCPP,
    isTC,
    notificationData,
    scrollDirection,
    setScrollDirection,
  } = useAuthContext();
  const { isCart } = useCartContext();
  const {
    setNavbarSearchQuery,
  } = useTestContext();
  const [isLocationClicked, setIsLocationClicked] = useState(false);

  const navbarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setNavbarSearchQuery("");
        setIsLocationClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="w-full h-fit bg-whiteColor pt-[16%] lg:pt-[110px]">
        <Topbar
          text="We are constantly working hard to bring you the best-in-class experience. Stay tuned!"
          scrollDirection={scrollDirection}
          setScrollDirection={setScrollDirection}
        />
        <div ref={navbarRef}>
          <Navbar
            scrollDirection={scrollDirection}
            searchVisible={searchVisible}
            locationCardVisibility={setIsLocationClicked}
            locationCardStatus={isLocationClicked}
            locationVisibility={locationVisibility}
          />
        </div>
        {children}
        {isAuth && <AuthComponent />}
        {isCart && <CartComponent />}
        {isTCPP && <TCPP />}
        {isTC && <TC />}
        <Footer />
      </div>
      <BottomNavbar/>
      <ChatBot/>
      {notificationData?.message?.length > 0 && <Notification />}
    </>
  );
};

export default UIWrapper;
